<div class="picture {pictureClass}" style="{pictureStyle}">

    <img src="{src}" alt="{src}" width="{width}" height="{height}" title="{title}" style={imgStyle} />

    <div class="picture__overlay">

        <slot name="overlay"/>

    </div>

</div>

<style>
    .picture {
        overflow: hidden;
        position: relative;
    }

    .picture img {
        display: block;
        height: 100%;
        object-position: center;
        transition: 150ms filter ease-out;
        width: 100%;
    }

    .picture.picture--fit-contain img {
        object-fit: contain;
    }

    .picture.picture--fit-cover img {        
        object-fit: cover;
    }

    .picture.picture--format-slice {
        height: 0;
        padding-bottom: 25%; 
    }

    .picture.picture--format-16-by-9, .picture.picture--format-hd {
        height: 0;
        padding-bottom: calc(100% / 16 * 9);
    }

    .picture.picture--format-cinemascope {
        height: 0;
        padding-bottom: calc(100% / 21 * 9);
    }

    .picture.picture--format-square {
        height: 0;
        padding-bottom: 100%; 
    }

    .picture.picture--format-fill-height {
        width: auto;
        height: 100%;
        min-height: 50vh;
    }

    .picture.picture--format-slice img, 
    .picture.picture--format-16-by-9 img,
    .picture.picture--format-hd img,
    .picture.picture--format-cinemascope img, 
    .picture.picture--format-square img,
    .picture.picture--format-fill-height img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .picture .picture__overlay {
        background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));
        color: white;
        bottom: 0;
        left: 0;
        opacity: 0;
        padding: 1rem 1rem 0.5rem 1rem;
        position: absolute;
        transition: 150ms opacity ease-out;
        transition-delay: 150ms;
        width: 100%;
    }

    .picture:hover {
        
    }

    .picture.picture--behaviour-reveal-blur:hover img {
        /* transform: scale(0.9, 0.9); */
        filter: blur(0.5rem);
    }

    .picture.picture--behaviour-reveal-blur:hover .picture__overlay {
        opacity: 1;
    }

    .picture.picture--behaviour-reveal:hover .picture__overlay {
        opacity: 1;
    }

    .picture.picture--clip-rectangle {

    }

    .picture.picture--clip-circle {
        border-radius: 100vw;
    }
</style>

<script>
    export default {
        computed: {
            imgStyle: ({ poiX, poiY, scale }) => {
                let styles = []

                if (poiX != 50 || poiY != 50) styles.push(`object-position:${poiX}% ${poiY}%;`)

                if (scale != 1) styles.push(`transform: scale(${scale}, ${scale});`)

                return styles.filter(Boolean).join(' ')
            },
            pictureClass: ({ format, fit, behaviour, clip }) => {
                let classes = []

                if (format) classes.push(`picture--format-${format}`)
                if (fit) classes.push(`picture--fit-${fit}`)
                if (behaviour) classes.push(`picture--behaviour-${behaviour}`)
                if (clip) classes.push(`picture--clip-${clip}`)

                return classes.filter(Boolean).join(' ')
            },
            pictureStyle: ({ color }) => {
                let styles = []

                if (color) styles.push(`background-color: ${color}`)

                return styles.filter(Boolean).join(' ')
            }
        },
        data() {
            return {
                behaviour: 'default',
                color: 'transparent',
                clip: 'rectangle',
                src: '',
                width: 0,
                height: 0,
                title: '',
                format: 'default',
                fit: 'contain',
                poiX: 50,
                poiY: 50,
                scale: 1
            }
        }
    }
</script>